import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

const PURPLE = '#a100aa';

export default function VerifiedPage() {
  const { i18n } = useTranslation();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const isKo = i18n.language === 'ko';

  useEffect(() => {
    const id = setTimeout(() => {
      navigate(isAuthenticated ? '/app' : '/login', { replace: true });
    }, 2200);
    return () => clearTimeout(id);
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ backgroundColor: '#0D1117' }}>
      <div style={{
        background: 'rgba(22,27,34,0.8)',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 16,
        padding: '48px 40px',
        textAlign: 'center',
        color: '#E6EDF3',
        maxWidth: 440,
        width: '100%',
      }}>
        <div style={{
          width: 72, height: 72, borderRadius: '50%',
          background: `${PURPLE}22`, color: PURPLE,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px', fontSize: 40, fontWeight: 800,
        }}>
          ✓
        </div>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>
          {isKo ? '이메일 인증 완료!' : 'Email verified!'}
        </h1>
        <p style={{ marginTop: 12, color: '#8B949E', fontSize: 14 }}>
          {isKo
            ? '잠시 후 자동으로 이동합니다…'
            : 'Redirecting you in a moment…'}
        </p>
      </div>
    </div>
  );
}
